export const login_zh = {

  login: {
    btn: "登录",
    VerificationCode: "请输入验证码",
    gainPhone: "获取手机验证码",
    gainEmail: "获取邮箱验证码",
    phone: "手机号",
    email: "邮箱",
    email2:"邮箱无法接收验证码?",
    authCode: "验证码",
    gain: "获取",
    PleasePassword: "请输入密码",
    PleaseEnterYourUserName: "请输入用户名 / 邮箱账号",
    PleaseEnterTheVerificationCode: "请输入验证码",
    PasswordLength: "密码长度不能小于6位",
    changePassword: "修改密码",
    oldPassword: "旧密码",
    newPassword: "新密码",
    ConfirmNewPassword: "确认新密码",
    randomPassword: "获取随机密码",
    userName: `用户名 / 邮箱`,
    login: "登录",
    password: "密码",
    account: "没有账户？",
    registered: "注册",
    forgotPassword: "忘记密码？",
    resetPassword: "重置密码",
    cancel: "取消",
    switchLanguages: "切换中英文",
    charts: "图表",
    agree: "必须勾选同意条款",
    terms: "我同意条款与条件，并同意根据隐私声明接收加密货币市场见解和更新",
    areAccount: "已拥有账户? ",
    inputEmail: "请输入您的电子邮件地址",
    sendEmail: "重新发送确认电子邮件",
    submit: "提交",
    dashboard: "仪表板",
    workbench: "工作台",
    transactionView: "交易视图",
    alarm: "警报",
    price: "价钱",
    video: "视频",
    insights: "见解",
    BBS: "论坛",
    resources: "资源",
    exit: "退出",
    mailbox: "邮箱",
    help: "帮助",
    title: "标题",
    placeholderTitle: "请输入", 
    kinds: "问题种类",
    description: "描述",
    description1: "请输入问题详情,我们回尽快为您解决.",
    attachment: "附件",
    Upload: " 将文件拖到此处，或",
    Upload1: "点击上传",
    Upload2: "只能上传jpg/png文件,且不超过500kb",
    home: "主页",
    feedback: "提交工单",
    smaPlaceholder: "请选择",
    emailCode: "请输入邮箱收到验证码",
    passwordValidation: "密码不能为空！",
    registeredName: "用户名",
    warningEmailCode: "请确认正确输入邮箱及用户名！",
    sendEmailCode: "邮箱验证码已发送！",
    newPassword: "新密码",
    emailVerification: "获取邮箱验证码",
    newPasswordCodeFail: "获取验证码失败，请稍后重试！",
    newPasswordSuccess: "重置密码成功,请登录！",
    getCode: "获取验证码",
    sending: "发送中",
    again: "重新获取",
    newLogin: "请重新登录!",
    personal: "个人中心",
    loginMask: "请先登录或者注册,才能查看此页面。",
    rewriteEmail: "邮箱已被注册，请重新输入。",
    inconsistency: "密码输入不一致请重新输入！",
    CodeFailNull: "验证码不能为空！",
    checkVerification: "请先获取邮箱验证码后正确输入！",
    PagePermission: "当前账户等级访问页面权限不足",
    userPermission: "当前账号权限",
    anonymousUser: "匿名用户",
    registerUser: "注册用户",
    advanceUser: "付费用户",
    vipUser: "特邀付费用户，公司股东",
    upgrade:"升级账户权限",
    admin:"网站管理员",
    support:"支持及维护人员, 审核者",
    verifier:"审核",
    accounting:"财会人员",
    oldPassword:"旧密码",
    oldEmail:"原邮箱",
    newEmail:"新邮箱",
    newEmail2:"填写新邮箱",
    CustomerManagemen:"客服管理",
    subscribe:"自定义订阅",
    personalData:"个人资料",
    subscribeCenter:"订阅中心",
    payManagement:"充值确认",
    payHistories:"转账记录",
    subscribeBoard:"消息订阅",
    server:"服务器错误！",
    timeout:"请求超时，请尝试刷新网页！",
    viewPage:"请先登录或者注册后查看页面!",
    AccountLevel:"账户等级",
    expense:"费用",
    accountUpgrade:"账号升级",
    monthlyPlay:"L3 月度付费用户",
    yearsPlay:"L3 年度付费用户",
    vipYearsPlay:"L4 vip年度付费用户",
    navigation:"输入搜索导航名",
    loginCheck:"请确认格式输入正确且不能为空！",
    set:"设置",
    backgroundAddress:"新增收款地址",
    backendPayment:"转账确认",
    backendRefund:"退款确认",
    backendWithdrawal:"提现订单",
    balance:"余额",
    Recharge:"充值",
    Withdrawal:"提现",
    currentLevel:"当前等级",
    backgroundPage:"后台管理",
    customerService:"联系客服",
    SMAwarning:"该指标SMA不能大于30天!",
    finance:"财务管理",
    userPrompt:"以字母开头,允许使用字母、数字、下划线，长度不小于3，不大于16位",
    passwordPrompt:"应包含大小写字母、数字和特殊字符，长度不小于8，不大于32位",
    paymentBackend:"数据中心",
    RechargeRecord:"充值记录",
    Statement:"申述",
    userNamePrompt:"请确认用户名格式正确及内容不能为空！",
    passwordPrompt1:"请确认密码格式正确及内容不能为空！",
    check1:"请勾选同意条款！",
    loginUpgrade:"请先注册登录！",
    linkError:"后端接口连接异常,请刷新重试",
    system:"系统接口异常",
    subscriptionLetter:"站内信",
    Alarm:"订阅与告警",
    publishObservations:"发布观察报告",
    Charts:"数据图表",
    researchReport:"研究报告",
    submitWork:"提交工单",
    historicalWork:"历史工单",
    onlineService:"在线客服",
    HistoryRecord:"历史记录",
    publishResearchReport:"发布研报",
    dataStatistics:"数据统计",
    registrationNotice:"新用户注册通知：",
    registrationPrompt:"1.对于新注册的用户，将自动获得30天的全部数据指标浏览权限(vip4等级,价值约$42)。",
    registrationPrompt2:"2.如果您对本网站提供了重要的意见或建议，我们会为您新增30天的vip4权限(价值约$42)，您可以在 个人中心=》联系客服 =》提交工单 页面提出您的意见和建议。获得赠送的用户以通告为准。",
    registrationPrompt3:"3.本网站所有数据仅作为参考，不构成投资建议。",
    registrationPrompt4:"4.浏览和使用本网站数据时请遵守您所在地当地的法律。",
    GoRegistered:"去注册",
  },
  placeholder: {
    data: '选择日期'
  },
  logins: {
    data: '登录'
  },
  // sidebar:{
  //   title:'你好'
  // }

};
export const login_en = {
  login: {
    btn: "Log in",
    VerificationCode: "Please enter the verification code",
    gainPhone: "Phone verification code",
    gainEmail: "Get email verification code",
    phone: "Mobile phone",
    email: "email",
    authCode: "Verification code",
    gain: "To obtain",
    PleasePassword: "Please enter your password",
    PleaseEnterYourUserName: "Please enter your user name / Email Account Number",
    PleaseEnterTheVerificationCode: "Please enter the verification code",
    PasswordLength: "Password length can not less than six",
    changePassword: "Change the password",
    oldPassword: "old Password",
    newPassword: "new Password",
    ConfirmNewPassword: "Confirm New Password",
    randomPassword: " get random password",
    userName: `user name / Email`,
    login: "login",
    password: "password",
    account: "There is no account?",
    registered: "Sign Up",
    forgotPassword: "Forgot password?",
    resetPassword: "To reset your password",
    cancel: "cancel",
    switchLanguages: "Switching between Chinese and English",
    charts: "chart",
    agree: "You have to check agree",
    terms: "I agree to the terms and conditions and agree to receive cryptocurrency market insights and updates in accordance with the privacy statement",
    areAccount: "Have an account? ",
    inputEmail: "Please enter your email address",
    sendEmail: "Resend the confirmation email",
    submit: "submit",
    dashboard: "The dashboard",
    workbench: "The workbench",
    transactionView: "Transaction view",
    alarm: "The alarm",
    price: "price",
    video: "video",
    insights: "insights",
    BBS: "BBS",
    resources: "resources",
    exit: "Log out",
    mailbox: "E-mail",
    help: "Help",
    title: "Title",
    placeholderTitle: "Please enter",
    kinds: "Types of questions",
    description: "Description",
    description1: "Please input the details of the problem, we will solve it for you as soon as possible.",
    attachment: "The attachment",
    Upload: " Drag the file here, or",
    Upload1: "Click on the upload",
    Upload2: "Only jpg/png files with a maximum size of 500kb can be uploaded",
    home: "Home",
    feedback: "Submit Work Order",
    smaPlaceholder: "Please select",
    emailCode: "Please enter the email to receive the verification code",
    passwordValidation: "The password cannot be empty!",
    registeredName: "User name",
    warningEmailCode: "Please confirm the correct input email and user name!",
    sendEmailCode: "Email verification code has been sent!",
    newPassword: "New password",
    emailVerification: "Get mailbox verification code",
    newPasswordCodeFail: "Failed to get CAPTCHA, please try again later!",
    newPasswordSuccess: "Password reset succeeded, please log in!",
    getCode: "Access authentication code",
    sending: "Sending",
    again: "Obtain again",
    newLogin: "Please log in again!",
    personal: "Personal Center",
    loginMask: "Please Login Or Register To View This Page。",
    rewriteEmail: "Email has been registered, please re-enter.",
    inconsistency: "Password input is inconsistent please re-enter!",
    CodeFailNull: "The verification code cannot be empty!",
    checkVerification: "Please first obtain the email verification code after the correct input!",
    PagePermission: "Insufficient access permissions to the page at the current account level",
    userPermission: "Permissions of current account",
    anonymousUser: "Anonymous user",
    registerUser: "Registered user",
    advanceUser: "Paying subscriber",
    vipUser: "VIP user",
    upgrade:"Upgrade account permissions",
    admin:"super administrator",
    support:"Support and maintenance staff, auditors",
    verifier:"audit",
    accounting:"Financial and accounting personnel",
    oldPassword:"Old password",
    oldEmail:"Original mailbox",
    newEmail:"New mailbox",   
    CustomerManagemen:"Customer management",
    subscribe:"Custom subscription",
    personalData:"Profile",
    subscribeCenter:"Subscription",
    payManagement:"Deposit",
    payHistories:"Transfer records",
    subscribeBoard:"Subscription",
    server:"Server error!",
    timeout:"Request timed out, please try refreshing the webpage!",
    viewPage:"Please login or register to view the page!",
    AccountLevel:"Account level", 
    expense:"expense",
    accountUpgrade:"Account Upgrade",
    monthlyPlay:"Monthly payer",
    yearsPlay:"Annual payer",
    vipYearsPlay:"vip annual paying user",
    navigation:"Search navigation",
    loginCheck:"Please confirm that the format input is correct and cannot be empty!",
    set:"set",
    backgroundAddress:"Add payment address",
    backendPayment:"Transfer",
    backendRefund:"Refund",
    backendWithdrawal:"Withdrawal Order",
    balance:"Balance",
    Recharge:"Recharge",
    Withdrawal:"Withdrawal",
    currentLevel:"Current level",
    backgroundPage:"Admin",
    customerService:"Contact",
    SMAwarning:"The SMA of this indicator cannot exceed 30 days!",
    finance:"financial management",
    userPrompt:"Start with letter Allow letters, numbers, and underscores Length not less than 3 but not more than 16 ",
    passwordPrompt:"Contains uppercase and lowercase letters, numbers, and special characters,Length not less than 8 and not more than 32",
    paymentBackend:"Data Center",
    RechargeRecord:"Recharge Record",
    email2:"Email cannot receive verification code?",
    Statement:"Statement",
    newEmail2:"fill in new Email",
    userNamePrompt:"Please confirm that the username format is correct and the content cannot be empty!",
    passwordPrompt1:"Please confirm that the password format is correct and the content cannot be empty!",
    check1:"Please check the agree clause!",
    loginUpgrade:"Please register and log in first!",
    linkError:"Backend interface connection exception, please refresh and try again",
    system:"System interface exception",
    subscriptionLetter:"Subscription letter",
    Alarm:"Subscription and Alarm",
    publishObservations:"Release observation report",
    Charts:"Charts",
    researchReport:"research Report",
    submitWork:"Submit Work Order",
    historicalWork:"Historical Work",
    onlineService:"Online Service",
    HistoryRecord:"History",
    publishResearchReport:"Publish research",
    dataStatistics:"Data Statistics",
    registrationNotice:"New user registration notification:",
    registrationPrompt:"1. For newly registered users, you will automatically receive 30 days of all indicators browsing privileges (VIP level 4, value of approximately $42).",
    registrationPrompt2:"2. If you provide important feedback or suggestions to us, we will add 30 days of VIP 4 privileges for you (value of approximately $42). You can provide your feedback and suggestions on the `Personal Center => Contact => Submit Work Order` page. Users who received gifts are subject to the announcement.",
    registrationPrompt3:"3. All data on this website is for reference only and does not constitute investment advice.",
    registrationPrompt4:"4. Please comply with the local laws of your location when browsing and using data on this website.",
    GoRegistered:"Go Registered",
 
  },
  placeholder: {
    data: 'select date'
  },
  logins: {
    data: 'login'
  },
  // sidebar:{
  //   title:'hallo'
  // }

};